  var ReportUtils = (function(){
    var self = {};
    var intlNumCache = {};

    self.getCachedINF = function(locString) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var key = JSON.stringify([locString, opts]);
      var inf = intlNumCache[key];

      if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        intlNumCache[key] = inf;
      }

      return inf;
    }

    calculateCoverage = function(data) {
      nonZeroPricesCount = _.select(data, function(item) { return item != 0 }).length
      return (nonZeroPricesCount / data.length) * 100
    }

    // chartData has totals hash
    // Filter total's hash based on selected bidders
    self.filter_totals = function( chartData, visibleBidders){
       var chartDataTotals =[] ;
       var dupChartDataTotals =[] ;

        //creating duplicate array by value
       dupChartDataTotals = $.extend(true, [], chartData.totals);

       $.each( dupChartDataTotals, function( key, bidderTotal){
        var bidder_entity = _.select(visibleBidders, function(name,bidder_key){ return name==bidderTotal.name;});
          if(!jQuery.isEmptyObject(bidder_entity)){
              chartDataTotals.push(bidderTotal);
          }
       });

      return chartDataTotals
    };

    // chartData has categories hash
    // Filter category's hash based on selected bidders
    self.filter_categories = function( chartData, visibleBidders){
       var chartDataCategories = [];
       var dupchartDataCategories = [];

       dupchartDataCategories = $.extend(true, [], chartData.categories);

       $.each( dupchartDataCategories, function( key, category){
         var bidder_entity = _.select(visibleBidders, function(name,bidder_key){ return name==category;});
           if(!jQuery.isEmptyObject(bidder_entity)){
               chartDataCategories.push(category);
           }
        });
       return chartDataCategories
    };

    self.adjust_average_median = function( chartData, restrictedBidderIndexes ){
      var is_average_checked = $('#biddersList .average').parents('li').find('input').last().is(':checked');
      var is_median_checked = $('#biddersList .median').parents('li').find('input').last().is(':checked');

       var chartDataSeries = [];
       var dupChartDataSeries = [];

       dupChartDataSeries = $.extend(true, [], chartData.series);


       $.each(dupChartDataSeries, function(index, serie){
           var restricted_indexes = 0;
           var recalculated_average = 0;
           var recalculated_median = 0;

           restrictedBidderIndexes.sort();

           for( var restrictedIndex=0; restrictedIndex < restrictedBidderIndexes.length; restrictedIndex++){
             // sliced data based on selected categories
             serie.data.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
             serie.data_with_percentages.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
             serie.notes.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
             serie.quantities.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
             //calculating average/median for individual categories
             if(is_average_checked && is_median_checked){
               recalculated_average = CommonUtils._recalculate_average(serie.data.slice(0,-4));
               recalculated_median = CommonUtils._recalculate_median(serie.data.slice(0,-4));
               serie.data[(serie.data.length-4)] = Math.round(recalculated_average);
               serie.data[(serie.data.length-3)] = Math.round(recalculated_median);
             }
             restricted_indexes += 1;
           }
           chartDataSeries.push(serie);
       });
      return chartDataSeries
    };

    self.calculate_statistics = function(chartDataSeries){
      var is_average_checked = $('#biddersList .average').parents('li').find('input').last().is(':checked');
      var is_median_checked = $('#biddersList .median').parents('li').find('input').last().is(':checked');
      var is_min_checked = $('#biddersList .min').parents('li').find('input').last().is(':checked');
      var is_max_checked = $('#biddersList .max').parents('li').find('input').last().is(':checked');
      var calculate_total_average = 0;
      var calculate_total_median = 0;
      var total_min = 0;
      var total_max = 0;
      $.map(chartDataSeries, function(serie, position){
        if(serie.parent == ""){
          if(is_average_checked){
            var avg_index = serie.data.length-4

            if(!is_median_checked)
              avg_index = serie.data.length-3

            calculate_total_average = calculate_total_average + (serie.data[avg_index])
          }

          if(is_median_checked){
            calculate_total_median = calculate_total_median + (serie.data[serie.data.length-3])
          }

          if(is_min_checked) { total_min += serie.data[serie.data.length-2] }
          if(is_max_checked) { total_max += serie.data[serie.data.length-1] }
        }
      });
      return {
        'average': calculate_total_average,
        'median': calculate_total_median,
        'min': total_min,
        'max': total_max
      }
    }

    self.prepareData = function( chartData, visibleBidders, restrictedBidderIndexes ){
      var chartDataTotals = [];
      var chartDataCategories = [];
      var chartDataSeries = [];

      chartDataTotals = ReportUtils.filter_totals(chartData, visibleBidders);
      chartDataCategories = ReportUtils.filter_categories(chartData, visibleBidders);
      chartDataSeries = ReportUtils.adjust_average_median(chartData, restrictedBidderIndexes);

      chartDataSeries = chartDataSeries.sort(function(a,b) { return a['lft'] - b['lft']});

      //Add grand total for each bidder
      var grandTotal = {};
      grandTotal["id"] = "grandtotal";
      grandTotal["category"] = "Overall";
      grandTotal["_collapsed"] = false;
      grandTotal["indent"] = 0;
      grandTotal["parent"] = null;

      var price_array = [];

      $.each( chartDataTotals, function( key, bidderTotal){
         if(bidderTotal.name != I18n.t('v4.tenders.graphs.average') && bidderTotal.name != I18n.t('v4.tenders.graphs.median')){
            var bidder_entity = _.select(visibleBidders, function(name,bidder_key){ return name==bidderTotal.name;});
            if(!jQuery.isEmptyObject(bidder_entity)){
                price_array.push(bidderTotal.total);
            }
         }
      });

      var total_average_and_median = ReportUtils.calculate_statistics(chartDataSeries);
      $.each( chartDataTotals, function( key, bidderTotal){
          grandTotal["price_percentage"+key] = '-';
          grandTotal["coverage"+key] = bidderTotal["coverage"];
          if (bidderTotal.name == I18n.t('v4.tenders.graphs.average')) {
            grandTotal["bidder"+key] = total_average_and_median["average"];
          } else if (bidderTotal.name == I18n.t('v4.tenders.graphs.median')) {
            grandTotal["bidder"+key] = total_average_and_median["median"];
          } else if (bidderTotal.name == I18n.t('v4.tenders.graphs.min')) {
            grandTotal["bidder"+key] = total_average_and_median["min"];
          } else if (bidderTotal.name == I18n.t('v4.tenders.graphs.max')) {
            grandTotal["bidder"+key] = total_average_and_median["max"];
          } else {
            grandTotal["bidder"+key] = bidderTotal.total;
          }
          // for calculations
          grandTotal["bidder"+key+"total"] = grandTotal["bidder"+key];
          // For displaying formatted total
          grandTotal["bidder"+key] = ReportUtils.getCachedINF('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(grandTotal["bidder"+key]);
      });

      grandTotal["max"] = _.max(chartDataTotals, function(element){ return element.total;}).total;
      grandTotal["min"] = _.min(chartDataTotals, function(element){ return element.total;}).total;

      var localData = _.map(chartDataSeries, function(serie, position){
        var item = {};
        item["id"]       = serie.self;
        item["category"] = serie.name;
        item["reference"] = serie.ref;
        if (serie.parent == ""){ // so it is root node
          item["indent"] = 0;
          item["parent"] = null;
          item["_collapsed"] = true;
        } else {
          item["indent"] = serie.parent.split(".").length;//Each . represents another level of indent
          item["parent"] = serie.parent;
          if( serie.self.split(".").length > 1)
            item["_collapsed"] = true;
        }

        if( serie.hasOwnProperty('isLeaf') )
          item["isLeaf"] = serie.isLeaf;
        if( serie.hasOwnProperty('modified') && serie.modified.length > 0 )
          item["modified"] = serie.modified;

        //Add all bidders' data
        for( i=0; i < chartDataCategories.length; i++){
          var datum = serie.data[i];
          var coverage = serie.coverages[i];
          var changes = serie.changes[i];
          item["bidder"+i] = ReportUtils.getCachedINF('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(datum);
          item["price_percentage"+i] = '0.00%';
          if(grandTotal["bidder"+i+"total"] > 0){
            item["price_percentage"+i] = (datum / grandTotal["bidder"+i+"total"] * 100).toFixed(2).toString() + '%';
          }
          if(chartDataCategories[i] == I18n.t('v4.tenders.graphs.average')){
            item['coverage'+i] = calculateCoverage(serie.coverages).toFixed(2).toString() + '%';
            if(serie.changes.length == 0) {
              item['changes'+i] = 0
            } else {
              sum = _.reduce(serie.changes, function(f, s) { return f + s });
              item['changes'+i] = (sum / serie.changes.length).toFixed(2).toString()
            }
          } else if(chartDataCategories[i] == I18n.t('v4.tenders.graphs.median')) {
            item['coverage'+i] = CommonUtils._recalculate_median(serie.coverages).toFixed(2) + '%';
            item['changes'+i] = CommonUtils._recalculate_median(serie.changes).toFixed(2)
          } else {
            item['coverage'+i] = coverage;
            item['changes'+i] = ReportUtils.getCachedINF('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(changes);
          }
        }

        item["max"] = _.max(serie.data);
        item["min"] = _.min(serie.data);
        item["quantity"]= serie.quantity;
        item["unit"]    = serie.unit;
        return item;
      });

      localData.push(grandTotal);

      return localData;
    };//prepareData

    return self;
  })();//ReportUtils
